import { AdvancedTourStep } from '../shared-types';
import { TaskTourProps } from './task-tour-props';

export function getS3WriterTourSteps({
	defaultStyles,
}: Readonly<TaskTourProps>): AdvancedTourStep[] {
	return [
		{
			id: 'aws-region',
			selector: '[data-tour="aws-region"]',
			content: 'Required: 	The AWS region that the S3 bucket was created in.',
		},
		{
			id: 'aws-access-key',
			selector: '[data-tour="aws-access-key"]',
			content: 'Required: The AWS Access Key ID that has access to the specified S3 bucket.',
		},
		{
			id: 'aws-secret-key',
			selector: '[data-tour="aws-secret-key"]',
			content: 'Required: The AWS Secret Access Key that has access to the S3 bucket.',
		},
		{
			id: 'aws-bucket-name',
			selector: '[data-tour="aws-bucket-name"]',
			content: 'Required: The AWS S3 bucket name.',
		},
		{
			id: 'test-connection',
			selector: '[data-tour="test-connection"]',
			content:
				'	The button will conduct a connection test to see if the task has the needed permissions to perform its functions. This test has 3 steps.' +
				'1. Connect to the bucket.' +
				'2. Write a test file to the bucket and delete it.' +
				'3. Read a random object from the bucket.' +
				'Once the test is completed a report will show to indicate the available permissions.',
		},
		{
			id: 'file-writer-config',
			selector: '[data-tour="file-writer-config"]',
			content: 'Select the type of file being written to the AWS S3 bucket',
		},
		{
			id: 's3-directory',
			selector: '[data-tour="s3-directory"]',
			content: 'The "folder" in which the document should be saved.',
		},
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
